export default __webpack_public_path__ + "static/media/shooting_package_icon.a00d18ac.svg";